<template>
  <div>
    <!-- <el-button circle icon="el-icon-arrow-left" @click="handlePrevDay"></el-button>-->
    <layout-flex seperator="space">
      <el-date-picker type="daterange" v-model="x" :value-format="valueFormat" format></el-date-picker>
      <!-- <el-button circle icon="el-icon-arrow-right" @click="handleNextDay"></el-button> -->
      <er-button btnType="play" :showIcon="true" :fab="true"></er-button>
      <er-list-filter :data="data" :props="props" :allowPersist="true"></er-list-filter>
    </layout-flex>
  </div>
</template>

<script>
import dummyData from "@/dummyData";
export default {
  data: function() {
    return {
      x: ["", ""],
      data: dummyData.data,
      props: {
        label: "resource_name"
      }
    };
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
